import { defineMessages } from "react-intl";
const messages = defineMessages({
    communitySearch: {
        id: "app.scanRequests.table.community.search",
        defaultMessage: "Community/Metro",
    },
    communityOrderBy: {
        id: "app.scanRequests.table.community.orderBy",
        defaultMessage: "Sort by",
    },
    communityOrderByOldest: {
        id: "app.scanRequests.table.community.orderBy.oldest",
        defaultMessage: "oldest",
    },
    communityOrderByNewest: {
        id: "app.scanRequests.table.community.orderBy.newest",
        defaultMessage: "newest",
    },
    communityMostRequests: {
        id: "app.scanRequests.table.community.orderBy.mostRequests",
        defaultMessage: "most requests",
    },
    communityNoData: {
        id: "app.scanRequests.table.community.noData",
        defaultMessage: "There aren't any communities available.",
    },
});
export default messages;
